// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1dPnl","header":"Messages_header__2qSyx"};